import React, { FunctionComponent } from "react";

import { ICodeBlock, ICodeBlockFields } from "@/types/generated/contentful";

type Props = {
  content: ICodeBlock;
};

const CodeBlock: FunctionComponent<Props> = ({ content }) => {
  return (
    <div
      className="h-full py-4"
      dangerouslySetInnerHTML={{
        __html: (content.fields as ICodeBlockFields).code!,
      }}
    />
  );
};

export default CodeBlock;
